import React, { useEffect,useState,createRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../components/custom-select/CustomSelect';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import moment from 'moment';
import * as RestService from '../../services/eisRest';
import sk from 'date-fns/locale/sk';
import "react-datepicker/dist/react-datepicker.css";
registerLocale('sk', sk)




  const AttendanceDetailAddDayModal = (props) => {

   

    const {t,i18n} = useTranslation();   
    const [isOpen, setIsOpen] = useState(false);
    const [day, setDay] = useState(null);  
    const [dateMin, setDateMin] = useState(null);  
    const [dateMax, setDateMax] = useState(null);     
    const [attendance, setAttendace] = useState(null);  
    const dialogRef = createRef();
    const [disabledSaveButton, setDisabledSaveButton] = useState(false);
    

    useEffect(() => {
      setDay(null);
      RestService.callAnyApi('attendance/getAttendance?id='+props.selectedRecord, null)
      .then((data) => {
        setAttendace(data);
        setDateMin(moment('01-'+data.month, 'DD-MM-YYYY').valueOf());
        let lastDay = moment(data.month, 'MM-YYYY').daysInMonth();
        setDateMax(moment(lastDay+'-'+data.month, 'DD-MM-YYYY').valueOf());
      })
      .catch((error) => {
        setAttendace(null);
        console.log(error);
      });
    }, [props.selectedRecord]);

   

  
  
    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    


    useEffect(() => {
      formik.resetForm();
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])

      

    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(t('attendance.label.'+serverMessage));
        }
    }


   

    const save = (url,values) => {
         
      setDisabledSaveButton(true) ;
    
      //console.log("Url for new day:"+ url+'?id='+attendance.id+'&dayOfMonth='+ moment(day).format("DD"));
      RestService.callAnyApi(url+'?id='+attendance.id+'&dayOfMonth='+ moment(day).format("DD"), null)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                      setDisabledSaveButton(false) ;
          })
          .catch((error) => {               
            showError(error,null);
            setDisabledSaveButton(false) ;
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    

      },
      validationSchema: Yup.object({
      //   month: Yup.string()     
       //   .required(t('general.message.required'))
       //   currency: Yup.string()     
       //   .required(t('general.message.required')),
        //  iban: Yup.string()     
         // .required(t('general.message.required')),
      }),
      onSubmit: (values) => {           
          save('attendance/setEmptyAttendanceDetailDay',values);         
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"
                    ref={dialogRef}
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('attendance.label.newDay')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                                
                         <div className="row"> 
                                <div className="col-12">
                                    <label>{t('attendance.label.day')}</label>        
                                    <div className="form-group">
                                                                                                                  
                                            <DatePicker
                                                className='form-control'                                         
                                                selected={day}
                                                onChange={(value) => setDay(new Date(value).getTime())}
                                                dateFormat="dd-MM-yyyy"
                                                //onMonthChange={handleMonthChange}
                                                minDate={dateMin}
                                                maxDate={dateMax}
                                                //showDayMonthYearPicker
                                                locale={i18n.language}                                                
                                            />                                                   						
                                    </div>
                               </div>
                         </div>      

                     
                           

                    </Modal.Body>
                    <Modal.Footer>                                                  
                          <Button className="btn-primary" type="submit"   disabled={disabledSaveButton}>{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
                               

     
      </>
    );
  };

 export default AttendanceDetailAddDayModal;